var isIE =
  '-ms-scroll-limit' in document.documentElement.style &&
  '-ms-ime-align' in document.documentElement.style;

function androidDeviceDetection() {
  var ua = navigator.userAgent.toLowerCase();
  var isAndroid = ua.indexOf('android') > -1; //&& ua.indexOf("mobile");
  if (isAndroid) {
    $('body').addClass('android');
  }
}

$(document).ready(function () {
  if (isIE) {
    $('html').addClass('ie-edge-11');
  }
  androidDeviceDetection();
});

var isIOS =
  /iPad|iPhone|iPod/.test(navigator.platform) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

$(document).ready(function () {
  if (isIOS) {
    $('body').addClass('ios');
  }
});
